export default __webpack_public_path__ + "static/media/product-image-20.bbcca46e.jpg";